<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const props = defineProps({
  pref: {
    type: String,
    required: true
  }
})

const route = useRoute()
const areaListTitle = '市区町村別の黄砂レーダー'
const { data: cityList } = await useFetch('/api/kosa/cityList', { query: { pref: props.pref } })
const basePath = route.path.replace(/\/[0-9]+\/$/, '/')
</script>

<template>
  <div class="spotlist">
    <SectionTitle :title="areaListTitle" />
    <div class="sub-division-container">
      <template
        v-for="city in cityList"
        :key="city.primary_subdivision_code"
      >
        <div class="sub-division-box">
          <h3 class="sub-division-title">
            {{ city.primary_subdivision_name }}
          </h3>
          <ul class="block">
            <li
              v-for="point in city.pointlist"
              :key="point.citycode"
            >
              <NuxtLink
                :to="`${basePath}${point.citycode}/`"
                class="link"
              >
                {{ point.cityname }}
              </NuxtLink>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .sub-division-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px;
    padding: 15px;
    border-radius: 8px;
    background-color: #eef1f8;
    .sub-division-box {
      display: flex;
      flex-direction: column;
      gap: 5px;
      .sub-division-title {
        font-weight: 700;
        color: #303030;
      }
    }
    .block {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    .link {
      display: flex;
      padding: 7px 10px;
      border-radius: 4px;
      background: #fff;
      box-shadow: 0 2px 4px #00000026;
      color: #303030;
      font-size: 13px;
      font-weight: 700;
      line-height: 13px;
      @media (any-hover: hover) {
        transition: box-shadow 0.2s ease-in-out;
        &:hover {
          box-shadow: 0 2px 6px #00000073;
        }
      }
    }
  }
}
</style>
